/* KROSPER product controllers. Original campaign behavior with owned lifecycle resources. */
(() => {
  const factories = {"kw5": function(root,config,life){const sectionId=root.dataset.krId;

    if(!root||root.dataset.kw5Ready==='true')return;
    root.dataset.kw5Ready='true';
    life.frame(function(){life.frame(function(){root.classList.add('is-loaded');});});

    function kw5CountryToFlag(code){
      code=String(code||'').trim().toUpperCase();
      if(!/^[A-Z]{2}$/.test(code))return '';
      return code.replace(/./g,function(character){return String.fromCodePoint(127397+character.charCodeAt(0));});
    }
    var currencyWrappers=Array.prototype.slice.call(root.querySelectorAll('[data-kw5-currency]'));
    root.querySelectorAll('[data-kw5-flag]').forEach(function(flag){
      flag.textContent=kw5CountryToFlag(flag.getAttribute('data-country'));
    });
    function closeCurrencyMenus(except){
      currencyWrappers.forEach(function(wrapper){
        if(wrapper===except)return;
        wrapper.classList.remove('is-open');
        var button=wrapper.querySelector('.kw5-currency-trigger');
        if(button)button.setAttribute('aria-expanded','false');
      });
    }
    currencyWrappers.forEach(function(wrapper){
      var trigger=wrapper.querySelector('.kw5-currency-trigger');
      if(!trigger)return;
      trigger.addEventListener('click',function(event){
        event.preventDefault();
        event.stopPropagation();
        var willOpen=!wrapper.classList.contains('is-open');
        closeCurrencyMenus(wrapper);
        wrapper.classList.toggle('is-open',willOpen);
        trigger.setAttribute('aria-expanded',willOpen?'true':'false');
      });
    });
    life.on(document,'click',function(event){
      if(event.target.closest(('.kw5--' + sectionId + ' [data-kw5-currency]')))return;
      closeCurrencyMenus();
    });
    life.on(document,'keydown',function(event){
      if(event.key==='Escape')closeCurrencyMenus();
    });

    var reduced=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    var hero=root.querySelector('[data-kw5-hero]');
    var heroVideo=root.querySelector('video.kw5-hero-scene');
    if(heroVideo){
      heroVideo.loop=false;
      heroVideo.muted=true;
      heroVideo.defaultMuted=true;
      heroVideo.setAttribute('muted','');
      heroVideo.setAttribute('playsinline','');
      var heroVideoVisible=true;
      var playHeroVideo=function(){
        if(reduced||!heroVideoVisible||heroVideo.dataset.kw5Complete==='true')return;
        var promise=heroVideo.play();
        if(promise&&promise.catch)promise.catch(function(){});
      };
      heroVideo.addEventListener('ended',function(){
        heroVideo.dataset.kw5Complete='true';
        heroVideo.pause();
      });
      heroVideo.addEventListener('error',function(){
        if(hero)hero.classList.add('is-video-failed');
      });
      if(reduced){
        var showHeroFinalFrame=function(){
          heroVideo.pause();
          if(isFinite(heroVideo.duration)&&heroVideo.duration>0){
            try{heroVideo.currentTime=Math.max(0,heroVideo.duration-.04);}catch(error){}
          }
        };
        if(heroVideo.readyState>=1)showHeroFinalFrame();
        else heroVideo.addEventListener('loadedmetadata',showHeroFinalFrame,{once:true});
      }else if('IntersectionObserver'in window){
        var videoObserver=new life.IntersectionObserver(function(entries){entries.forEach(function(entry){
          heroVideoVisible=entry.isIntersecting;
          if(heroVideoVisible)playHeroVideo();else heroVideo.pause();
        });},{threshold:.08});
        videoObserver.observe(heroVideo);
      }
      heroVideo.addEventListener('canplay',playHeroVideo,{once:true});
      life.on(document,'visibilitychange',function(){
        if(document.hidden)heroVideo.pause();else playHeroVideo();
      });
    }
    var stage=root.querySelector('[data-kw5-product-stage]'),productWrap=root.querySelector('[data-kw5-product-wrap]');
    var scenes=Array.prototype.slice.call(root.querySelectorAll('[data-kw5-scene]'));
    var reveals=Array.prototype.slice.call(root.querySelectorAll('[data-kw5-reveal]'));
    var impactStory=root.querySelector('[data-kw5-impact-story]'),impactLayers=Array.prototype.slice.call(root.querySelectorAll('[data-kw5-impact-layer]')),impactActive=0;
    var targetX=0,targetY=0,currentX=0,currentY=0,ticking=false;

    root.querySelectorAll('.kw5-kit-word').forEach(function(el,index){el.style.setProperty('--kw-order',index);});
    root.querySelectorAll('.kw5-detail').forEach(function(el,index){el.style.setProperty('--kw-delay',(index*85)+'ms');});

    function clamp(value,min,max){return Math.max(min,Math.min(max,value));}
    function setImpact(index){
      index=clamp(index,0,Math.max(0,impactLayers.length-1));
      if(index===impactActive&&impactLayers[index]&&impactLayers[index].classList.contains('is-active'))return;
      impactActive=index;
      impactLayers.forEach(function(layer,i){layer.classList.toggle('is-active',i===index);});
    }
    function motion(){
      ticking=false;
      var vh=window.innerHeight||800;
      scenes.forEach(function(scene){var box=scene.getBoundingClientRect(),progress=clamp((vh-box.top)/(vh+box.height),0,1);scene.style.setProperty('--kw-scene',progress.toFixed(4));});
      if(impactStory&&impactLayers.length&&window.innerWidth>780){
        var impactBox=impactStory.getBoundingClientRect(),impactTravel=Math.max(1,impactBox.height-vh),impactProgress=clamp(-impactBox.top/impactTravel,0,.9999);
        setImpact(Math.floor(impactProgress*impactLayers.length));
      }
      if(stage&&productWrap){
        var r=stage.getBoundingClientRect(),scrollShift=clamp((r.top+r.height/2-vh/2)/vh,-1.2,1.2)*-28;
        currentX+=(targetX-currentX)*.11;currentY+=(targetY-currentY)*.11;
        productWrap.style.transform='translate3d('+(-currentX*8)+'px,'+(scrollShift+currentY*7)+'px,0) rotateX('+(-currentY*2.2)+'deg) rotateY('+(currentX*3.2)+'deg)';
        stage.style.setProperty('--kw-product-depth',String(Math.abs(currentX)+Math.abs(currentY)));
        if(Math.abs(targetX-currentX)>.002||Math.abs(targetY-currentY)>.002)scheduleMotion();
      }
    }
    function scheduleMotion(){if(!ticking){ticking=true;life.frame(motion);}}
    if(!reduced){
      life.on(window,'scroll',scheduleMotion,{passive:true});
      /* Shopify's editor can scroll an internal preview container instead of window. */
      life.on(document,'scroll',scheduleMotion,{passive:true,capture:true});
      life.on(window,'resize',scheduleMotion,{passive:true});
      if(window.visualViewport){
        life.on(window.visualViewport,'scroll',scheduleMotion,{passive:true});
        life.on(window.visualViewport,'resize',scheduleMotion,{passive:true});
      }
      if(stage&&window.matchMedia('(pointer:fine)').matches){
        stage.addEventListener('pointermove',function(event){var box=stage.getBoundingClientRect();targetX=clamp((event.clientX-box.left)/box.width*2-1,-1,1);targetY=clamp((event.clientY-box.top)/box.height*2-1,-1,1);scheduleMotion();});
        stage.addEventListener('pointerleave',function(){targetX=0;targetY=0;scheduleMotion();});
      }
      scheduleMotion();
    }

    if(reduced||!('IntersectionObserver'in window)){
      reveals.forEach(function(el){el.classList.add('is-in');});
      scenes.forEach(function(el){el.classList.add('is-active');el.style.setProperty('--kw-scene','1');});
    }else{
      var revealObserver=new life.IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-in');revealObserver.unobserve(entry.target);}});},{threshold:.14,rootMargin:'0px 0px -8% 0px'});
      reveals.forEach(function(el){revealObserver.observe(el);});
      var sceneObserver=new life.IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-active');sceneObserver.unobserve(entry.target);}});},{threshold:.1,rootMargin:'0px 0px -10% 0px'});
      scenes.forEach(function(el){sceneObserver.observe(el);});
    }

    var pageSections=Array.prototype.slice.call(root.querySelectorAll('[data-kw12-section]'));
    var pageLinks=Array.prototype.slice.call(root.querySelectorAll('[data-kw12-nav-link]'));
    pageLinks.forEach(function(link){link.addEventListener('click',function(event){var target=root.querySelector(link.getAttribute('href'));if(!target)return;event.preventDefault();var mobile=window.innerWidth<=780,offset=(document.querySelector('.kr-header')?.getBoundingClientRect().height||(mobile?config.mobile_nav_offset:config.nav_offset))+18;window.scrollTo({top:Math.max(0,target.getBoundingClientRect().top+window.pageYOffset-offset),behavior:reduced?'auto':'smooth'});});});
    if(pageSections.length&&pageLinks.length&&'IntersectionObserver'in window){
      var navObserver=new life.IntersectionObserver(function(entries){
        var visible=entries.filter(function(entry){return entry.isIntersecting;}).sort(function(a,b){return b.intersectionRatio-a.intersectionRatio;})[0];
        if(!visible)return;
        var key=visible.target.getAttribute('data-kw12-section');
        pageLinks.forEach(function(link){link.classList.toggle('is-active',link.getAttribute('data-kw12-nav-link')===key);});
      },{threshold:[.08,.2,.4],rootMargin:'-24% 0px -58% 0px'});
      pageSections.forEach(function(section){navObserver.observe(section);});
    }

    var builder=root.querySelector('[data-kw5-builder]');
    if(builder){
      var builderName=builder.querySelector('[data-kw5-builder-name]'),builderCopy=builder.querySelector('[data-kw5-builder-description]'),builderSignal=builder.querySelector('.kw5-builder-signal');
      var builderBusy=false;
      function syncBuilderVideos(target){builder.querySelectorAll('[data-kw5-builder-visual]').forEach(function(visual){var video=visual.querySelector('video');if(!video)return;if(visual.getAttribute('data-kw5-builder-visual')===target&&!reduced){var promise=video.play();if(promise&&promise.catch)promise.catch(function(){});}else video.pause();});}
      syncBuilderVideos('bochka');
      builder.querySelectorAll('.kw5-builder-tab').forEach(function(tab){tab.addEventListener('click',function(){
        if(builderBusy||tab.classList.contains('is-active'))return;
        builderBusy=true;
        builder.querySelectorAll('.kw5-builder-tab').forEach(function(t){var active=t===tab;t.classList.toggle('is-active',active);t.setAttribute('aria-selected',active?'true':'false');});
        var target=tab.getAttribute('data-builder-target');
        builder.querySelectorAll('[data-kw5-builder-visual]').forEach(function(visual){visual.classList.toggle('is-active',visual.getAttribute('data-kw5-builder-visual')===target);});
        syncBuilderVideos(target);
        var swap=function(){builderName.textContent=tab.getAttribute('data-builder-name');builderCopy.textContent=tab.getAttribute('data-builder-copy');};
        if(builderName.animate&&!reduced){
          var outgoing=builderName.animate([{clipPath:'inset(0)',transform:'translateX(0)'},{clipPath:'inset(0 0 0 100%)',transform:'translateX(34px)'}],{duration:240,easing:'cubic-bezier(.55,0,1,.45)',fill:'forwards'});
          builderCopy.animate([{opacity:1,transform:'translateY(0)'},{opacity:0,transform:'translateY(14px)'}],{duration:170,easing:'ease-in',fill:'forwards'});
          outgoing.onfinish=function(){
            swap();
            builderName.animate([{clipPath:'inset(0 100% 0 0)',transform:'translateX(-42px)'},{clipPath:'inset(0)',transform:'translateX(0)'}],{duration:560,easing:'cubic-bezier(.16,1,.3,1)',fill:'forwards'});
            builderCopy.animate([{opacity:0,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}],{duration:520,delay:90,easing:'cubic-bezier(.16,1,.3,1)',fill:'forwards'}).onfinish=function(){builderBusy=false;};
          };
        }else{swap();builderBusy=false;}
        if(builderSignal.animate&&!reduced)builderSignal.animate([{transform:'scaleX(.06)',filter:'brightness(2.4)'},{transform:'scaleX(1)',filter:'brightness(1)'}],{duration:720,easing:'cubic-bezier(.16,1,.3,1)'});
        if(builder.animate&&!reduced)builder.animate([{transform:'translateX(0)'},{transform:'translateX(-7px)'},{transform:'translateX(0)'}],{duration:360,easing:'cubic-bezier(.2,.8,.2,1)'});
      });});
    }

    var player=root.querySelector('[data-kw5-player]');
    if(player){
      var audio=new life.Audio();
audio.addEventListener("play",()=>window.KrosperSystem?.pauseOthers(audio));audio.preload='metadata';audio.volume=.85;
      var tracks=Array.prototype.slice.call(player.querySelectorAll('[data-kw5-track]')),visible=tracks.slice(),activeIndex=-1,raf=null,loading=false,playToken=0,peaks=null,waveProgress=0,decodeToken=0,canvasMetrics=null,hitLevel=0,nextPreload=new life.Audio();nextPreload.preload='auto';
      var mainPlay=player.querySelector('[data-kw5-main-play]'),playIcon=player.querySelector('[data-kw5-play-icon]'),nowTitle=player.querySelector('[data-kw5-now-title]'),nowStyle=player.querySelector('[data-kw5-now-style]'),nowMeta=player.querySelector('[data-kw5-now-meta]'),positionEl=player.querySelector('[data-kw5-position]'),currentEl=player.querySelector('[data-kw5-current]'),durationEl=player.querySelector('[data-kw5-duration]'),wave=player.querySelector('[data-kw5-wave]'),canvas=player.querySelector('[data-kw5-canvas]'),ctx=canvas?canvas.getContext('2d'):null,empty=player.querySelector('[data-kw5-empty]'),countEl=player.querySelector('[data-kw5-track-count]');
      function time(value){if(!isFinite(value)||value<0)value=0;var m=Math.floor(value/60),s=Math.floor(value%60);return m+':'+(s<10?'0':'')+s;}
      function pad(value){return String(value).length<2?'0'+value:String(value);}
      function cleanTitle(value){var title=(value||'Kick demo').replace(/\.[a-z0-9]+$/i,'').replace(/^KRP[\s_-]*/i,'').replace(/^KW[\s_-]*/i,'').replace(/_+/g,' ').replace(/\s+/g,' ').trim();title=title.replace(/\s+\d{2,3}\s*BPM\b/ig,'').replace(/\s+/g,' ').trim();return title||'Kick demo';}
      function bpm(value){var match=(value||'').match(/(\d{2,3})[\s_-]*BPM\b/i);return match?match[1]+' BPM':'';}
      function categoryName(value){var names={full_demo:'Full demo',finished:'Finished kick',loops:'Kick loop',melody:'Melody Vault',fake_drops:'Fake drop'};return names[value]||'Audio preview';}
      function trackMeta(track){var parts=[categoryName(track.getAttribute('data-category')||'finished'),styleName(track.getAttribute('data-style'))],tempo=bpm(track.getAttribute('data-title'));if(tempo)parts.push(tempo);return parts.filter(Boolean).join(' / ');}
      function styleName(value){if(!value||value==='all_styles')return 'KICK WARFARE';return value.replace(/_/g,' ').toUpperCase();}
      function visual(playing){player.classList.toggle('is-playing',playing);if(!playing){hitLevel=0;player.style.setProperty('--kw-hit','0');}playIcon.innerHTML=playing?'<path d="M6 5h4v14H6zm8 0h4v14h-4z"/>':'<path d="M8 5v14l11-7z"/>';mainPlay.setAttribute('aria-label',playing?'Pause current demo':'Play current demo');tracks.forEach(function(track){var action=track.querySelector('.kw5-track-action');if(action)action.textContent=track.classList.contains('is-active')&&playing?'Pause':'Play';});}
      function resizeCanvas(){if(!canvas||!ctx)return null;var box=canvas.getBoundingClientRect(),ratio=window.devicePixelRatio||1;canvas.width=Math.max(1,Math.floor(box.width*ratio));canvas.height=Math.max(1,Math.floor(box.height*ratio));ctx.setTransform(ratio,0,0,ratio,0,0);canvasMetrics={w:box.width,h:box.height};return canvasMetrics;}
      function draw(progress){if(!canvas||!ctx)return;var size=canvasMetrics||resizeCanvas();if(!size)return;var played=Math.max(0,Math.min(1,progress||0)),bars=Math.max(44,Math.floor(size.w/5)),step=size.w/bars,barWidth=Math.max(1.4,Math.min(2.8,step*.58)),mid=size.h/2;ctx.clearRect(0,0,size.w,size.h);for(var i=0;i<bars;i++){var ratio=i/Math.max(1,bars-1),source=peaks&&peaks.length?peaks[Math.min(peaks.length-1,Math.floor(ratio*(peaks.length-1)))]:.08+Math.abs(Math.sin(i*.73))*.045,height=Math.max(3,source*size.h*.78),x=i*step+(step-barWidth)/2;ctx.fillStyle=ratio<=played?'rgba(255,59,47,'+(.78+hitLevel*.18)+')':'rgba(224,223,216,.22)';ctx.fillRect(x,mid-height/2,barWidth,height);}if(played>0&&played<1){var playX=size.w*played;ctx.fillStyle='rgba(255,255,255,.84)';ctx.fillRect(playX,6,1,size.h-12);}}
      function loadWave(src){peaks=null;draw(0);var token=++decodeToken;if(!src||!window.fetch)return;fetch(src).then(function(r){if(!r.ok)throw new Error('wave');return r.arrayBuffer();}).then(function(buffer){var AC=window.AudioContext||window.webkitAudioContext;if(!AC)throw new Error('context');var context=new AC();return context.decodeAudioData(buffer).then(function(decoded){var data=decoded.getChannelData(0),samples=240,block=Math.max(1,Math.floor(data.length/samples)),next=[];for(var i=0;i<samples;i++){var start=i*block,end=Math.min(data.length,start+block),peak=0;for(var j=start;j<end;j+=Math.max(1,Math.floor(block/80)))peak=Math.max(peak,Math.abs(data[j]));next.push(peak);}return next;}).finally(function(){context.close();});}).then(function(next){if(token!==decodeToken)return;peaks=next;draw(waveProgress);}).catch(function(){if(token===decodeToken){peaks=null;draw(waveProgress);}});}
      function update(){stop();var duration=audio.duration||0,current=audio.currentTime||0;waveProgress=duration?current/duration:0;if(!audio.paused&&peaks&&peaks.length){var peak=peaks[Math.min(peaks.length-1,Math.floor(waveProgress*(peaks.length-1)))]||0,target=Math.pow(peak,1.7);hitLevel+=(target-hitLevel)*(target>hitLevel ? .48 : .1);player.style.setProperty('--kw-hit',hitLevel.toFixed(3));}wave.setAttribute('aria-valuenow',Math.round(waveProgress*100));currentEl.textContent=time(current);durationEl.textContent=time(duration);draw(waveProgress);if(!audio.paused&&!audio.ended)raf=life.frame(update);}
      function stop(){if(raf){life.cancelFrame(raf);raf=null;}}
      function choose(track,shouldPlay){
        var index=tracks.indexOf(track);if(index<0)return;++playToken;audio.pause();stop();
        tracks.forEach(function(t){t.classList.remove('is-active');t.setAttribute('aria-pressed','false');});track.classList.add('is-active');track.setAttribute('aria-pressed','true');activeIndex=index;
        var rawTitle=track.getAttribute('data-title')||'Kick demo',visibleIndex=visible.indexOf(track);nowTitle.textContent=cleanTitle(rawTitle);nowStyle.textContent=styleName(track.getAttribute('data-style'));nowMeta.textContent=trackMeta(track);positionEl.textContent=pad(visibleIndex<0?index+1:visibleIndex+1)+' / '+pad(visible.length||tracks.length);
        if(!reduced&&nowTitle.animate){nowTitle.animate([{clipPath:'inset(0 100% 0 0)',transform:'translateX(-34px)'},{clipPath:'inset(0)',transform:'translateX(0)'}],{duration:620,easing:'cubic-bezier(.16,1,.3,1)'});nowStyle.animate([{opacity:0,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:430,easing:'cubic-bezier(.16,1,.3,1)'});track.animate([{backgroundColor:'rgba(225,6,0,.28)'},{backgroundColor:'rgba(225,6,0,.12)'}],{duration:520,easing:'ease-out'});}
        var src=track.getAttribute('data-src');if(!src)return;var absolute=new URL(src,document.baseURI).href;if(audio.src!==absolute){audio.src=src;audio.load();loadWave(src);}primeNext();if(shouldPlay){play();track.scrollIntoView({block:'nearest',behavior:reduced?'auto':'smooth'});}else{audio.pause();audio.currentTime=0;visual(false);update();}
      }
      function primeNext(){if(!visible.length)return;var at=visible.indexOf(tracks[activeIndex]),next=visible[(at<0?0:at+1)%visible.length],src=next&&next.getAttribute('data-src');if(src&&nextPreload.src!==new URL(src,document.baseURI).href)nextPreload.src=src;}
      function play(){if(activeIndex<0&&visible.length)choose(visible[0],false);if(activeIndex<0||!audio.src)return;if(audio.ended)audio.currentTime=0;loading=true;var ticket=++playToken;audio.play().then(function(){if(life.disposed||ticket!==playToken)return;loading=false;visual(true);stop();update();}).catch(function(){if(life.disposed||ticket!==playToken)return;loading=false;visual(false);});}
      function toggle(){if(loading)return;if(audio.paused)play();else audio.pause();}
      function step(direction){if(!visible.length)return;var at=visible.indexOf(tracks[activeIndex]),next=at<0?0:(at+direction+visible.length)%visible.length;choose(visible[next],true);}
      function seek(clientX){var box=wave.getBoundingClientRect(),percent=Math.max(0,Math.min(1,(clientX-box.left)/box.width));if(audio.duration)audio.currentTime=percent*audio.duration;update();}
      tracks.forEach(function(track){var name=track.querySelector('.kw5-track-name'),meta=track.querySelector('.kw5-track-style');track.setAttribute('aria-pressed','false');if(name)name.textContent=cleanTitle(track.getAttribute('data-title'));if(meta)meta.textContent=trackMeta(track);track.addEventListener('click',function(){if(track.classList.contains('is-active'))toggle();else choose(track,true);});});
      mainPlay.addEventListener('click',toggle);
      player.querySelector('[data-kw5-prev]').addEventListener('click',function(){step(-1);});
      player.querySelector('[data-kw5-next]').addEventListener('click',function(){step(1);});
      player.querySelector('[data-kw5-mute]').addEventListener('click',function(){audio.muted=!audio.muted;this.style.color=audio.muted?'var(--kw-hot)':'';});
      player.querySelector('[data-kw5-volume]').addEventListener('input',function(){audio.volume=parseFloat(this.value);audio.muted=false;});
      wave.addEventListener('click',function(event){seek(event.clientX);});
      wave.addEventListener('keydown',function(event){if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();audio.currentTime=Math.max(0,Math.min(audio.duration||0,audio.currentTime+(event.key==='ArrowRight'?5:-5)));update();}});
      audio.addEventListener('loadedmetadata',update);
      audio.addEventListener('pause',function(){++playToken;loading=false;stop();visual(false);update();});
      audio.addEventListener('ended',function(){stop();visual(false);step(1);});
      audio.addEventListener('error',function(){++playToken;loading=false;visual(false);nowMeta.textContent='Demo unavailable. Try another track.';});
      resizeCanvas();draw(0);life.on(window,'resize',function(){resizeCanvas();draw(waveProgress);},{passive:true});countEl.textContent=tracks.length?tracks.length+' sounds':'';if(tracks.length)choose(tracks[0],false);else empty.style.display='block';
    }

    function connectSticky(){
      var sticky=document.querySelector(('.kw5-sticky--' + sectionId + ''));
      if(!hero||!sticky)return;
      var dismissed=false,heroVisible=true,finalVisible=false,close=sticky.querySelector('[data-kw5-sticky-close]');
      function syncSticky(){var show=!dismissed&&!heroVisible&&!finalVisible;sticky.classList.toggle('is-visible',show);sticky.setAttribute('aria-hidden',show?'false':'true');sticky.inert=!show;}
      if(close)close.addEventListener('click',function(){dismissed=true;syncSticky();});
      if(!('IntersectionObserver'in window)){
        function fallbackSticky(){var heroRect=hero.getBoundingClientRect(),finalSection=root.querySelector('.kw5-final'),finalRect=finalSection?finalSection.getBoundingClientRect():null;heroVisible=heroRect.bottom>0;finalVisible=!!finalRect&&finalRect.top<window.innerHeight*.88;syncSticky();}
        life.on(window,'scroll',fallbackSticky,{passive:true});fallbackSticky();return;
      }
      var stickyObserver=new life.IntersectionObserver(function(entries){entries.forEach(function(entry){heroVisible=entry.isIntersecting;syncSticky();});},{threshold:0});
      stickyObserver.observe(hero);
      var finalSection=root.querySelector('.kw5-final');
      if(finalSection){var finalObserver=new life.IntersectionObserver(function(entries){entries.forEach(function(entry){finalVisible=entry.isIntersecting;syncSticky();});},{threshold:.12});finalObserver.observe(finalSection);}
    }
    life.timeout(connectSticky,0);
  
},
"kab": function(root,config,life){const sectionId=root.dataset.krId;

  if(!root||root.getAttribute('data-kab-initialized')==='true')return;
  root.setAttribute('data-kab-initialized','true');
  var kabStickyScope=document.querySelector(('.kab-sticky--' + sectionId + ''));
  function kabScopedAll(selector){
    var nodes=Array.from(root.querySelectorAll(selector));
    if(kabStickyScope)nodes=nodes.concat(Array.from(kabStickyScope.querySelectorAll(selector)));
    return nodes.filter(function(node,index,list){return list.indexOf(node)===index;});
  }
  var reduceMQ=window.matchMedia?window.matchMedia('(prefers-reduced-motion: reduce)'):{matches:false};
  var nowFn=(window.performance&&performance.now)?function(){return performance.now();}:function(){return Date.now();};

  /* reveals */
  var els=root.querySelectorAll('[data-r]');
  if(!('IntersectionObserver' in window)){els.forEach(function(el){el.classList.add('on');});}
  else{var io=new life.IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('on');io.unobserve(e.target);}});},{threshold:0.08});els.forEach(function(el){io.observe(el);});}

  /* sticky */
  var heroEl=root.querySelector('[data-kab-hero]'),sticky=kabStickyScope;
  if(heroEl&&sticky&&'IntersectionObserver' in window){var sio=new life.IntersectionObserver(function(entries){entries.forEach(function(e){sticky.classList.toggle('show',!e.isIntersecting);});},{threshold:0});sio.observe(heroEl);}

  /* scroll progress + hero parallax (single passive handler) */
  var progFill=document.querySelector(('.kab-progress--' + sectionId + ' [data-kab-progress]'));
  var heroImg=root.querySelector('[data-kab-heroimg]');
  var ticking=false,lastY=0;
  function updateScroll(y){
    if(progFill){ var h=document.documentElement.scrollHeight-window.innerHeight; var r=h>0?Math.min(1,Math.max(0,y/h)):0; progFill.style.transform='scaleX('+r+')'; }
    if(heroImg&&!reduceMQ.matches){ heroImg.style.transform='translate3d(0,'+Math.min(18,y*0.035).toFixed(2)+'px,0)'; }
  }
  function onScroll(){ lastY=window.pageYOffset||document.documentElement.scrollTop||0; if(!ticking){ life.frame(function(){ updateScroll(lastY); ticking=false; }); ticking=true; } }
  life.on(window,'scroll',onScroll,{passive:true});
  updateScroll(window.pageYOffset||0);

  /* animated stat counters */
  function countUp(el){
    var raw=el.getAttribute('data-kab-count')||el.textContent;
    var m=raw.match(/[\d.,]+/);
    if(!m){ return; }
    var numStr=m[0].replace(/,/g,'');
    var target=parseFloat(numStr);
    if(isNaN(target)){ return; }
    var prefix=raw.slice(0,m.index), suffix=raw.slice(m.index+m[0].length);
    var decimals=(numStr.indexOf('.')>-1)?numStr.split('.')[1].length:0;
    if(reduceMQ.matches){ el.textContent=raw; return; }
    var dur=1500,start=null;
    el.textContent=prefix+(0).toFixed(decimals)+suffix;
    function step(ts){
      if(start===null)start=ts;
      var p=Math.min(1,(ts-start)/dur), eased=1-Math.pow(1-p,3);
      el.textContent=prefix+(target*eased).toFixed(decimals)+suffix;
      if(p<1)life.frame(step); else el.textContent=raw;
    }
    life.frame(step);
  }
  var counters=root.querySelectorAll('[data-kab-count]');
  if(counters.length){
    if(!('IntersectionObserver' in window)){ counters.forEach(countUp); }
    else{ var cio=new life.IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){countUp(e.target);cio.unobserve(e.target);}});},{threshold:0.5}); counters.forEach(function(c){cio.observe(c);}); }
  }

  /* magnetic CTAs (desktop, fine pointer) */
  var fine=window.matchMedia&&window.matchMedia('(pointer:fine)').matches;
  if(fine&&!reduceMQ.matches){
    root.querySelectorAll('[data-kab-magnetic]').forEach(function(btn){
      btn.addEventListener('pointermove',function(e){
        var r=btn.getBoundingClientRect();
        var mx=e.clientX-(r.left+r.width/2), my=e.clientY-(r.top+r.height/2);
        btn.style.transform='translate3d('+(mx*0.16).toFixed(2)+'px,'+(my*0.24).toFixed(2)+'px,0)';
      });
      btn.addEventListener('pointerleave',function(){ btn.style.transform=''; });
    });
  }

  /* marquee pause on hover */
  var mt=root.querySelector('.mq-track'),mw=root.querySelector('.mq-wrap');
  if(mt&&mw){mw.addEventListener('mouseenter',function(){mt.style.animationPlayState='paused';});mw.addEventListener('mouseleave',function(){mt.style.animationPlayState='running';});}

  /* FAQ accordion */
  root.querySelectorAll('.faq-item').forEach(function(item){
    var btn=item.querySelector('.faq-btn');
    if(!btn)return;
    btn.addEventListener('click',function(){
      var open=item.classList.contains('open');
      root.querySelectorAll('.faq-item').forEach(function(i){
        i.classList.remove('open');
        var b=i.querySelector('.faq-btn'); if(b)b.setAttribute('aria-expanded','false');
      });
      if(!open){ item.classList.add('open'); btn.setAttribute('aria-expanded','true'); }
    });
  });

  /* currency selector */
  function kabCountryFlag(code){
    code=String(code||'').trim().toUpperCase();
    if(!/^[A-Z]{2}$/.test(code))return'🏳️';
    return String.fromCodePoint(127397+code.charCodeAt(0),127397+code.charCodeAt(1));
  }
  function kabCloseCurrencies(except){
    kabScopedAll('[data-kab-currency].open').forEach(function(el){
      if(except&&el===except)return;
      el.classList.remove('open');
      var b=el.querySelector('.kab-currency-trigger');
      if(b)b.setAttribute('aria-expanded','false');
    });
  }
  kabScopedAll('.kab-currency-form').forEach(function(form,index){
    form.id=('KabCurrencyForm-' + sectionId + '-')+index;
  });
  kabScopedAll('[data-kab-flag]').forEach(function(el){
    el.textContent=kabCountryFlag(el.getAttribute('data-country'));
  });
  kabScopedAll('[data-kab-currency]').forEach(function(sel){
    var btn=sel.querySelector('.kab-currency-trigger');
    if(!btn)return;
    btn.addEventListener('click',function(e){
      e.preventDefault(); e.stopPropagation();
      var willOpen=!sel.classList.contains('open');
      kabCloseCurrencies(sel);
      sel.classList.toggle('open',willOpen);
      btn.setAttribute('aria-expanded',willOpen?'true':'false');
    });
    sel.addEventListener('click',function(e){ e.stopPropagation(); });
  });
  life.on(document,'click',function(){ kabCloseCurrencies(); });
  life.on(document,'keydown',function(e){ if(e.key==='Escape')kabCloseCurrencies(); });

  /* ─── AJAX ADD TO CART + VERIFIED MIDI ARMORY REWARD V6 ─── */
  var kabMidiVariantId=config.midi_id;
  var kabMidiPrice=config.midi_price;
  var kabMidiImage=config.midi_image;
  var kabCartBusy=false;

  function kabRoutesRoot(){
    var r=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)?window.Shopify.routes.root:'/';
    return r.replace(/\/?$/,'/');
  }
  function kabCartSectionsURL(){
    var url=window.location.pathname||kabRoutesRoot();
    return url+(url.indexOf('?')>-1?'&':'?')+'sections=cart-drawer,cart-icon-bubble';
  }
  function kabReadJSON(response){
    return response.json().catch(function(){return{};}).then(function(data){
      if(!response.ok){
        var message=data&&((data.description||data.message))?String(data.description||data.message):'cart_request_failed';
        var err=new Error(message);
        err.status=response.status;
        throw err;
      }
      return data;
    });
  }
  function kabRequest(path,options){
    return fetch(kabRoutesRoot()+String(path||'').replace(/^\//,''),options||{}).then(kabReadJSON);
  }
  function kabPost(path,body){
    return kabRequest(path,{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
      body:JSON.stringify(body||{})
    });
  }
  function kabEnsureSections(data){
    if(data&&data.sections&&data.sections['cart-drawer']&&data.sections['cart-icon-bubble'])return Promise.resolve(data);
    return fetch(kabCartSectionsURL(),{method:'GET',cache:'no-store',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}})
    .then(kabReadJSON)
    .then(function(sections){
      data=data||{};
      data.sections=sections||{};
      return data;
    })
    .catch(function(){return data||{};});
  }
  function kabUpdateCartBubble(sections){
    if(!sections||!sections['cart-icon-bubble'])return;
    var tmp=document.createElement('div');
    tmp.innerHTML=sections['cart-icon-bubble'];
    var fresh=tmp.querySelector('#cart-icon-bubble');
    var live=document.querySelector('#cart-icon-bubble');
    if(fresh&&live){
      live.innerHTML=fresh.innerHTML;
      if(fresh.getAttribute('aria-label'))live.setAttribute('aria-label',fresh.getAttribute('aria-label'));
    }
  }
  function kabResetCartDrawerTop(){
    var drawer=document.querySelector('cart-drawer');
    function reset(){
      var targets=[];
      ['#CartDrawer','cart-drawer-items','#CartDrawer-CartItems','.drawer__contents'].forEach(function(sel){
        document.querySelectorAll(sel).forEach(function(el){if(targets.indexOf(el)===-1)targets.push(el);});
      });
      targets.forEach(function(el){
        try{el.scrollTop=0;}catch(e){}
        try{if(typeof el.scrollTo==='function')el.scrollTo({top:0,left:0,behavior:'auto'});}catch(e){}
      });
      if(drawer){
        drawer.classList.remove('is-empty');
        var inner=drawer.querySelector('.drawer__inner');
        if(inner)inner.classList.remove('is-empty');
      }
    }
    [0,90,240].forEach(function(ms){life.timeout(reset,ms);});
  }
  function kabOpenCartDrawer(data){
    var drawer=document.querySelector('cart-drawer');
    var rendered=false;
    if(drawer&&data&&data.sections&&data.sections['cart-drawer']&&typeof drawer.renderContents==='function'){
      try{drawer.renderContents(data);rendered=true;}catch(error){console.warn('KROSPER drawer render fallback:',error);}
    }
    if(!rendered&&drawer&&data&&data.sections&&data.sections['cart-drawer']){
      var tmp=document.createElement('div');
      tmp.innerHTML=data.sections['cart-drawer'];
      var freshDrawer=tmp.querySelector('cart-drawer');
      var freshInner=freshDrawer?freshDrawer.querySelector('.drawer__inner'):tmp.querySelector('.drawer__inner');
      var liveInner=drawer.querySelector('.drawer__inner');
      if(liveInner&&freshInner){liveInner.innerHTML=freshInner.innerHTML;liveInner.classList.remove('is-empty');}
      drawer.classList.remove('is-empty');
      if(typeof drawer.open==='function')drawer.open();
      else{drawer.classList.add('active');document.body.classList.add('overflow-hidden');}
    }
    kabResetCartDrawerTop();
  }
  function kabItemHandle(item){
    if(!item)return'';
    return item.handle||item.product_handle||((String(item.url||'').match(/\/products\/([^/?]+)/)||[])[1]||'');
  }
  function kabIsMidiBonus(item){
    return !!(item&&kabItemHandle(item)==='krosper-midi-armory'&&item.properties&&item.properties._krosper_bonus==='ultimate-bundle');
  }
  function kabGetCart(){
    return kabRequest('cart.js',{method:'GET',cache:'no-store',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}});
  }
  function kabAddItems(items){
    return kabPost('cart/add.js',{
      items:items,
      sections:'cart-drawer,cart-icon-bubble',
      sections_url:window.location.pathname
    });
  }
  function kabRemoveCartLine(line){
    return kabPost('cart/change.js',{
      line:line,
      quantity:0,
      sections:'cart-drawer,cart-icon-bubble',
      sections_url:window.location.pathname
    });
  }
  function kabHideAutomaticGiftLabels(){
    var drawer=document.querySelector('cart-drawer');
    if(!drawer)return;
    drawer.querySelectorAll('.discounts__discount').forEach(function(el){
      if((el.textContent||'').toUpperCase().indexOf('MIDI ARMORY UNLOCKED')>-1)el.style.display='none';
    });
  }
  function kabDecorateMidiGift(){
    var drawer=document.querySelector('cart-drawer');
    if(!drawer)return null;
    var link=drawer.querySelector('#CartDrawer a.cart-item__name[href*="/products/krosper-midi-armory"]');
    if(!link)return null;
    var row=link.closest('tr.cart-item');
    if(!row)return null;

    row.classList.add('kab-midi-gift-row');
    var details=link.closest('.cart-item__details');
    if(details&&!details.querySelector('.kab-midi-gift-badge')){
      var badge=document.createElement('div');
      badge.className='kab-midi-gift-badge';
      badge.textContent='EXCLUSIVE BONUS UNLOCKED';
      details.insertBefore(badge,link);
    }
    if(details&&!details.querySelector('.kab-midi-gift-meta')){
      var meta=document.createElement('div');
      meta.className='kab-midi-gift-meta';
      var files=document.createElement('span');
      files.textContent='8,656 MIDI FILES';
      var value=document.createElement('span');
      value.textContent=kabMidiPrice+' VALUE';
      meta.appendChild(files);
      meta.appendChild(value);
      link.insertAdjacentElement('afterend',meta);
    }
    row.querySelectorAll('.cart-item__final-price,.cart-item__price-wrapper .cart-item__discounted-prices > span.price--end').forEach(function(price){
      price.textContent='FREE';
    });
    kabHideAutomaticGiftLabels();
    return row;
  }
  function kabWaitForMidiGift(callback,attempt){
    var row=kabDecorateMidiGift();
    if(row){callback(row);return;}
    attempt=attempt||0;
    if(attempt>=18)return;
    life.timeout(function(){kabWaitForMidiGift(callback,attempt+1);},55);
  }
  function kabShowMidiUnlock(){
    var drawer=document.querySelector('cart-drawer');
    var inner=drawer?drawer.querySelector('.drawer__inner'):null;
    if(!inner)return;
    var old=inner.querySelector('.kab-midi-unlock');
    if(old)old.remove();

    var unlock=document.createElement('div');
    unlock.className='kab-midi-unlock';
    unlock.setAttribute('role','status');
    unlock.setAttribute('aria-live','polite');
    unlock.setAttribute('aria-atomic','true');
    var imageHTML=kabMidiImage?'<div class="kab-midi-unlock__product"><img src="'+kabMidiImage+'" alt="KROSPER MIDI ARMORY"></div>':'';
    unlock.innerHTML=
      '<div class="kab-midi-unlock__panel">'+
        '<span class="kab-midi-unlock__eyebrow">KROSPER SYSTEM REWARD</span>'+
        '<h3 class="kab-midi-unlock__title">BONUS <span>UNLOCKED</span></h3>'+
        imageHTML+
        '<div class="kab-midi-unlock__name">KROSPER MIDI ARMORY</div>'+
        '<div class="kab-midi-unlock__meta">8,656 MIDI FILES<br>THE COMPLETE HARD MUSIC MIDI SYSTEM</div>'+
        '<div class="kab-midi-unlock__price"><s>'+kabMidiPrice+'</s><strong>FREE</strong></div>'+
      '</div>';
    inner.appendChild(unlock);
    life.frame(function(){life.frame(function(){unlock.classList.add('is-visible');});});

    var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var visibleFor=reduced?1250:2700;
    life.timeout(function(){
      unlock.classList.add('is-leaving');
      life.timeout(function(){
        unlock.remove();
        var row=kabDecorateMidiGift();
        if(row){
          row.classList.remove('is-revealed');
          life.frame(function(){row.classList.add('is-revealed');});
          life.timeout(function(){row.classList.remove('is-revealed');},1500);
        }
      },360);
    },visibleFor);
  }
  function kabSetButtonState(btn,html,disabled){
    if(!btn)return;
    btn.disabled=!!disabled;
    btn.setAttribute('aria-busy',disabled?'true':'false');
    btn.innerHTML=html;
  }
  function kabVerifyNewBonus(){
    return kabGetCart().then(function(cart){
      var items=cart.items||[];
      var bonusIndex=-1;
      for(var i=0;i<items.length;i++){
        if(kabIsMidiBonus(items[i])){bonusIndex=i;break;}
      }
      if(bonusIndex<0)return{verified:false,cart:cart,reason:'missing'};
      if(items[bonusIndex].final_line_price===0)return{verified:true,cart:cart,bonus:items[bonusIndex]};
      return kabRemoveCartLine(bonusIndex+1).then(kabEnsureSections).then(function(data){
        return{verified:false,removed:true,data:data,reason:'discount'};
      });
    });
  }
  function kabATC(form,btn){
    if(!form||!btn||btn.disabled||kabCartBusy)return;
    var vid=form.querySelector('[name="id"]');
    if(!vid)return;

    kabCartBusy=true;
    var ultimateId=parseInt(vid.value,10);
    var originalHTML=btn.innerHTML;
    kabSetButtonState(btn,'<span style="opacity:.68;font-size:10px;letter-spacing:.2em">UNLOCKING…</span>',true);

    var attemptedGift=false;
    var addData=null;
    kabGetCart()
    .catch(function(){return{items:[]};})
    .then(function(cart){
      var midiAlreadyInCart=(cart.items||[]).some(function(item){return kabItemHandle(item)==='krosper-midi-armory';});
      var items=[{id:ultimateId,quantity:1}];
      if(kabMidiVariantId&&!midiAlreadyInCart){
        attemptedGift=true;
        items.push({
          id:parseInt(kabMidiVariantId,10),
          quantity:1,
          parent_id:ultimateId,
          properties:{_krosper_bonus:'ultimate-bundle'}
        });
      }
      return kabAddItems(items).catch(function(error){
        if(!attemptedGift)throw error;
        console.warn('KROSPER bonus add fallback:',error);
        attemptedGift=false;
        return kabAddItems([{id:ultimateId,quantity:1}]);
      });
    })
    .then(function(data){
      addData=data;
      if(!attemptedGift)return{verified:false,skipped:true};
      return kabVerifyNewBonus();
    })
    .then(function(verification){
      if(verification&&verification.removed&&verification.data)addData=verification.data;
      return kabEnsureSections(addData).then(function(data){
        return{data:data,verification:verification||{verified:false}};
      });
    })
    .then(function(state){
      kabUpdateCartBubble(state.data.sections);
      kabOpenCartDrawer(state.data);
      var rewardVerified=!!(state.verification&&state.verification.verified);

      if(rewardVerified){
        kabWaitForMidiGift(function(){kabShowMidiUnlock();});
        kabSetButtonState(btn,'<span style="color:#4cff8c">✓ BONUS UNLOCKED</span>',true);
      }else{
        if(state.verification&&state.verification.reason==='discount'){
          console.error('KROSPER MIDI Armory was removed because the automatic discount did not make it free.');
        }
        kabSetButtonState(btn,'<span style="color:#4cff8c">✓ ADDED</span>',true);
      }

      try{document.dispatchEvent(new CustomEvent('cart:refresh'));}catch(e){}
      try{document.dispatchEvent(new CustomEvent('cart:updated',{detail:state.data}));}catch(e){}
      life.timeout(function(){
        kabSetButtonState(btn,originalHTML,false);
        kabCartBusy=false;
      },rewardVerified?3000:1900);
    })
    .catch(function(error){
      console.error('KROSPER Ultimate add failed:',error);
      kabSetButtonState(btn,'<span style="color:#ff6b63">TRY AGAIN</span>',false);
      life.timeout(function(){
        kabSetButtonState(btn,originalHTML,false);
        kabCartBusy=false;
      },1800);
    });
  }

  var kabProductForms=[];
  var kabForms=Array.from(root.querySelectorAll('.kab-form'));
  if(kabStickyScope)kabForms=kabForms.concat(Array.from(kabStickyScope.querySelectorAll('.kab-form')));
  kabForms.forEach(function(form){
    if(!form||kabProductForms.indexOf(form)>-1||!form.querySelector('[name="id"]'))return;
    kabProductForms.push(form);
    form.addEventListener('submit',function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      kabATC(form,form.querySelector('button[type="submit"]'));
    });
  });
  /* ─── PREMIUM WAVEFORM CONSOLE ─── */
  var playerEl=root.querySelector('[data-kab-player]');
  if(playerEl){
    var tracks=Array.from(playerEl.querySelectorAll('[data-kab-track]'));
    if(tracks.length){
      var titleEl=playerEl.querySelector('[data-kab-track-title]');
      var catEl=playerEl.querySelector('[data-kab-track-cat]');
      var stateEl=playerEl.querySelector('[data-kab-state]');
      var playBtn=playerEl.querySelector('[data-kab-play]');
      var playIcon=playerEl.querySelector('[data-kab-pi]');
      var pauseIcon=playerEl.querySelector('[data-kab-pa]');
      var prevBtn=playerEl.querySelector('[data-kab-prev]');
      var nextBtn=playerEl.querySelector('[data-kab-next]');
      var timeCur=playerEl.querySelector('[data-kab-tc]');
      var timeTot=playerEl.querySelector('[data-kab-tt]');
      var waveWrap=playerEl.querySelector('[data-kab-wave]');
      var canvas=playerEl.querySelector('[data-kab-canvas]');
      var tip=playerEl.querySelector('[data-kab-tip]');
      var ctx=(canvas&&canvas.getContext)?canvas.getContext('2d'):null;
      var hasPath2D=(typeof Path2D!=='undefined');

      var audio=new life.Audio();
audio.addEventListener("play",()=>window.KrosperSystem?.pauseOthers(audio));
      audio.preload='metadata';
      var cur=0,playing=false,raf=null,dragging=false,hoverRatio=-1;
      var revealStart=0,revealDur=660;
      var cssW=0,cssH=0,dpr=1;
      var bars=[],BAR_W=3,BAR_GAP=2,MIN_BARS=28;
      var playedGrad=null;

      function hashStr(str){var h=2166136261>>>0;str=String(str||'');for(var i=0;i<str.length;i++){h^=str.charCodeAt(i);h=Math.imul(h,16777619);}return h>>>0;}
      function genWave(seed,n){
        var s=(seed||1)>>>0;
        function rnd(){s=(Math.imul(s,1664525)+1013904223)>>>0;return s/4294967296;}
        var p1=rnd()*6.28318,p2=rnd()*6.28318,f1=3+Math.floor(rnd()*4),f2=7+Math.floor(rnd()*9);
        var out=new Array(n);
        for(var i=0;i<n;i++){
          var t=n>1?i/(n-1):0;
          var env=Math.pow(Math.sin(Math.PI*t),0.55);
          var w1=0.5+0.5*Math.sin(t*6.28318*f1+p1);
          var w2=0.5+0.5*Math.sin(t*6.28318*f2+p2);
          var nz=rnd();
          var v=env*(0.42*w1+0.30*w2+0.42*nz);
          if(v<0)v=0; if(v>1)v=1;
          out[i]=0.12+0.88*v;
        }
        return out;
      }
      function buildBars(n){ var t=tracks[cur]; bars=genWave(hashStr((t?t.getAttribute('data-title'):'')+'#'+cur), n); }
      function buildGradient(){
        if(!ctx)return;
        playedGrad=ctx.createLinearGradient(0,0,0,cssH);
        playedGrad.addColorStop(0,'rgba(255,72,60,1)');
        playedGrad.addColorStop(0.5,'rgba(225,6,0,1)');
        playedGrad.addColorStop(1,'rgba(150,3,0,1)');
      }
      function measure(){
        if(!ctx||!waveWrap)return;
        var r=waveWrap.getBoundingClientRect();
        cssW=Math.max(1,Math.round(r.width));
        cssH=Math.max(1,Math.round(r.height));
        dpr=Math.min(window.devicePixelRatio||1,2);
        canvas.width=Math.round(cssW*dpr);
        canvas.height=Math.round(cssH*dpr);
        canvas.style.width=cssW+'px';
        canvas.style.height=cssH+'px';
        ctx.setTransform(dpr,0,0,dpr,0,0);
        var unit=BAR_W+BAR_GAP;
        var n=Math.max(MIN_BARS,Math.floor((cssW+BAR_GAP)/unit));
        buildBars(n); buildGradient(); drawOnce();
      }
      function addBar(path,x,y,w,h,rad){
        var rr=Math.min(rad,w/2,h/2); if(rr<0)rr=0;
        path.moveTo(x+rr,y);
        path.lineTo(x+w-rr,y); path.quadraticCurveTo(x+w,y,x+w,y+rr);
        path.lineTo(x+w,y+h-rr); path.quadraticCurveTo(x+w,y+h,x+w-rr,y+h);
        path.lineTo(x+rr,y+h); path.quadraticCurveTo(x,y+h,x,y+h-rr);
        path.lineTo(x,y+rr); path.quadraticCurveTo(x,y,x+rr,y);
      }
      function draw(ts){
        if(!ctx)return;
        var n=bars.length; if(!n)return;
        var now=ts||nowFn();
        var unit=(cssW+BAR_GAP)/n;
        var bw=Math.max(2,unit-BAR_GAP);
        var prog=(audio.duration&&isFinite(audio.duration))?audio.currentTime/audio.duration:0;
        if(prog<0)prog=0; if(prog>1)prog=1;
        var playedX=prog*cssW;
        var rev=1;
        if(revealStart){rev=(now-revealStart)/revealDur; if(rev<0)rev=0; if(rev>1)rev=1; rev=1-Math.pow(1-rev,3);}
        var animate=playing&&!reduceMQ.matches;
        ctx.clearRect(0,0,cssW,cssH);
        /* faint center baseline */
        ctx.fillStyle='rgba(255,255,255,0.045)';
        ctx.fillRect(0,Math.round(cssH/2)-0.5,cssW,1);
        var pPath=hasPath2D?new Path2D():null;
        var rPath=hasPath2D?new Path2D():null;
        for(var i=0;i<n;i++){
          var x=i*unit;
          var amp=bars[i]*rev;
          if(animate){
            amp=bars[i]*rev*(0.80+0.20*Math.sin(now*0.005+i*0.45));
            var d=Math.abs((x+bw/2)-playedX);
            var zone=1-d/(unit*5); if(zone<0)zone=0;
            amp+=zone*0.22*Math.abs(Math.sin(now*0.011+i*0.7));
          }
          if(amp>1)amp=1;
          var bh=amp*cssH; if(bh<2)bh=2;
          var y=(cssH-bh)/2;
          var isPlayed=(x+bw/2)<=playedX;
          if(hasPath2D){ addBar(isPlayed?pPath:rPath,x,y,bw,bh,2); }
          else { ctx.fillStyle=isPlayed?'rgba(225,6,0,1)':'rgba(255,255,255,0.13)'; ctx.fillRect(x,y,bw,bh); }
        }
        if(hasPath2D){
          ctx.fillStyle='rgba(255,255,255,0.13)'; ctx.fill(rPath);
          ctx.save();
          ctx.shadowColor='rgba(225,6,0,0.5)'; ctx.shadowBlur=12;
          ctx.fillStyle=playedGrad||'rgba(225,6,0,1)'; ctx.fill(pPath);
          ctx.restore();
        }
        if(hoverRatio>=0){ var hx=hoverRatio*cssW; ctx.fillStyle='rgba(255,255,255,0.22)'; ctx.fillRect(hx-0.5,0,1,cssH); }
      }
      function drawOnce(){ if(!ctx)return; life.frame(function(t){draw(t);}); }
      function loop(ts){
        draw(ts);
        var revealing=revealStart&&((ts||nowFn())-revealStart)<revealDur;
        if((playing&&!reduceMQ.matches)||revealing){ raf=life.frame(loop); }
        else { raf=null; if(revealStart)revealStart=0; }
      }
      function startLoop(){ if(ctx&&!raf)raf=life.frame(loop); }
      function fmt(s){ if(isNaN(s)||s<0||!isFinite(s))return'0:00'; var m=Math.floor(s/60),sec=Math.floor(s%60); return m+':'+(sec<10?'0':'')+sec; }

      function setPlay(s){
        playing=s;
        if(playIcon)playIcon.style.display=s?'none':'block';
        if(pauseIcon)pauseIcon.style.display=s?'block':'none';
        playerEl.classList.toggle('is-playing',s);
        if(stateEl)stateEl.textContent=s?'Now Playing':'Paused';
        if(ctx){ if(s)startLoop(); else drawOnce(); }
      }
      function load(idx,autoplay){
        cur=((idx%tracks.length)+tracks.length)%tracks.length;
        var t=tracks[cur];
        if(titleEl)titleEl.textContent=t?t.getAttribute('data-title'):'';
        if(catEl)catEl.textContent=t?t.getAttribute('data-category'):'';
        tracks.forEach(function(tr,i){ tr.classList.toggle('active',i===cur); });
        var url=t?t.getAttribute('data-url'):'';
        if(url&&url.trim()){ audio.src=url; try{audio.load();}catch(e){} }
        if(timeCur)timeCur.textContent='0:00';
        if(timeTot)timeTot.textContent=t?(t.getAttribute('data-duration')||'0:00'):'0:00';
        if(waveWrap)waveWrap.setAttribute('aria-valuenow','0');
        if(ctx){ buildBars(bars.length||MIN_BARS); if(!reduceMQ.matches){ revealStart=nowFn(); startLoop(); } else { drawOnce(); } }
        if(autoplay)play();
      }
      function play(){
        var url=tracks[cur]?tracks[cur].getAttribute('data-url'):'';
        if(!url||!url.trim()){ setPlay(true); return; }
        var p=audio.play();
        if(p&&p.then){ p.then(function(){setPlay(true);}).catch(function(){setPlay(false);}); }
        else { setPlay(true); }
      }
      function pause(){ try{audio.pause();}catch(e){} setPlay(false); }

      if(playBtn)playBtn.addEventListener('click',function(){ if(playing){pause();}else{play();} });
      if(prevBtn)prevBtn.addEventListener('click',function(){ load(cur-1,playing); });
      if(nextBtn)nextBtn.addEventListener('click',function(){ load(cur+1,playing); });
      tracks.forEach(function(t,i){ t.addEventListener('click',function(){ load(i,true); }); });

      audio.addEventListener('timeupdate',function(){
        if(timeCur)timeCur.textContent=fmt(audio.currentTime);
        if(timeTot&&audio.duration&&isFinite(audio.duration))timeTot.textContent=fmt(audio.duration);
        if(waveWrap&&audio.duration&&isFinite(audio.duration))waveWrap.setAttribute('aria-valuenow',Math.round(audio.currentTime/audio.duration*100));
        if(reduceMQ.matches)drawOnce();
      });
      audio.addEventListener('loadedmetadata',function(){ if(timeTot&&audio.duration&&isFinite(audio.duration))timeTot.textContent=fmt(audio.duration); });
      audio.addEventListener('ended',function(){ load(cur+1,true); });
      audio.addEventListener('error',function(){ setPlay(false); });

      function ratioFromEvent(e){
        var r=canvas.getBoundingClientRect();
        var cx=(e.clientX!=null)?e.clientX:((e.touches&&e.touches[0])?e.touches[0].clientX:0);
        var v=(cx-r.left)/r.width; if(v<0)v=0; if(v>1)v=1; return v;
      }
      function applySeek(ratio){ if(audio.duration&&isFinite(audio.duration))audio.currentTime=ratio*audio.duration; drawOnce(); }
      function showTip(ratio){ if(!tip)return; tip.style.opacity='1'; tip.style.left=(ratio*cssW)+'px'; tip.textContent=fmt((audio.duration&&isFinite(audio.duration))?ratio*audio.duration:0); }
      function hideTip(){ if(tip)tip.style.opacity='0'; }

      if(waveWrap&&canvas){
        waveWrap.addEventListener('pointerdown',function(e){ dragging=true; try{waveWrap.setPointerCapture(e.pointerId);}catch(err){} var r=ratioFromEvent(e); hoverRatio=r; applySeek(r); showTip(r); });
        waveWrap.addEventListener('pointermove',function(e){ var r=ratioFromEvent(e); hoverRatio=r; showTip(r); if(dragging){applySeek(r);} else if(!playing){drawOnce();} });
        waveWrap.addEventListener('pointerup',function(){ dragging=false; });
        waveWrap.addEventListener('pointercancel',function(){ dragging=false; });
        waveWrap.addEventListener('pointerleave',function(){ if(!dragging){ hoverRatio=-1; hideTip(); if(!playing)drawOnce(); } });
        waveWrap.addEventListener('keydown',function(e){
          var k=e.key;
          if(k===' '||k==='Enter'){ e.preventDefault(); if(playing){pause();}else{play();} return; }
          if(!audio.duration||!isFinite(audio.duration))return;
          var handled=true;
          if(k==='ArrowRight'){ audio.currentTime=Math.min(audio.duration,audio.currentTime+5); }
          else if(k==='ArrowLeft'){ audio.currentTime=Math.max(0,audio.currentTime-5); }
          else if(k==='Home'){ audio.currentTime=0; }
          else if(k==='End'){ audio.currentTime=audio.duration; }
          else handled=false;
          if(handled){ e.preventDefault(); drawOnce(); }
        });
      }

      var rzT;
      life.on(window,'resize',function(){ life.clearTimeout(rzT); rzT=life.timeout(measure,160); });
      if('ResizeObserver' in window && waveWrap){ try{ new life.ResizeObserver(function(){ measure(); }).observe(waveWrap); }catch(e){} }

      if(ctx)measure();
      load(0,false);
    }
  }

},
"ksv": function(root,config,life){const sectionId=root.dataset.krId;

  if (!root) return;

  /* ── CURRENCY SELECTOR ─────────────────────────── */
  function ksvCountryToFlag(code){
    code = String(code || '').trim().toUpperCase();
    if (!/^[A-Z]{2}$/.test(code)) return '';
    return code.replace(/./g, function(char){
      return String.fromCodePoint(127397 + char.charCodeAt(0));
    });
  }

  document.querySelectorAll('[data-ksv-flag]').forEach(function(el){
    el.textContent = ksvCountryToFlag(el.getAttribute('data-country'));
  });

  document.querySelectorAll('[data-ksv-currency]').forEach(function(wrapper){
    var trigger = wrapper.querySelector('.ksv-currency-trigger');
    if (!trigger) return;

    trigger.addEventListener('click', function(e){
      e.preventDefault();
      var isOpen = wrapper.classList.contains('is-open');
      document.querySelectorAll('[data-ksv-currency].is-open').forEach(function(open){
        open.classList.remove('is-open');
        var btn = open.querySelector('.ksv-currency-trigger');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen){
        wrapper.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  life.on(document,'click', function(e){
    if (e.target.closest('[data-ksv-currency]')) return;
    document.querySelectorAll('[data-ksv-currency].is-open').forEach(function(open){
      open.classList.remove('is-open');
      var btn = open.querySelector('.ksv-currency-trigger');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  });

  life.on(document,'keydown', function(e){
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-ksv-currency].is-open').forEach(function(open){
      open.classList.remove('is-open');
      var btn = open.querySelector('.ksv-currency-trigger');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  });

  /* ── SCROLL REVEAL ─────────────────────────────── */
  var reveals = root.querySelectorAll('[data-reveal]');
  if (!('IntersectionObserver' in window)) {
    reveals.forEach(function(el){ el.classList.add('is-visible'); });
  } else {
    var revealIO = new life.IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){
          e.target.classList.add('is-visible');
          revealIO.unobserve(e.target);
        }
      });
    }, { threshold: 0.08 });
    reveals.forEach(function(el){ revealIO.observe(el); });
  }

  /* ── COUNTER ANIMATION ─────────────────────────── */
  var counters = root.querySelectorAll('[data-count]');
  if (counters.length && 'IntersectionObserver' in window){
    var countIO = new life.IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting) return;
        var el = e.target;
        var target = parseInt(el.getAttribute('data-count'), 10);
        if (isNaN(target)) return;
        var duration = 1800;
        var startTime = null;
        function tick(ts){
          if (!startTime) startTime = ts;
          var progress = Math.min((ts - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(eased * target);
          if (progress < 1) life.frame(tick);
          else el.textContent = target;
        }
        life.frame(tick);
        countIO.unobserve(el);
      });
    }, { threshold: 0.5 });
    counters.forEach(function(el){ countIO.observe(el); });
  }

  /* ── MARQUEE PAUSE ON HOVER ────────────────────── */
  var marquee = root.querySelector('.ksv-marquee');
  var mWrap   = root.querySelector('.ksv-marquee-wrap');
  if (marquee && mWrap){
    mWrap.addEventListener('mouseenter', function(){ marquee.style.animationPlayState = 'paused'; });
    mWrap.addEventListener('mouseleave', function(){ marquee.style.animationPlayState = 'running'; });
  }

  /* ── DEMO AUDIO PLAYER ─────────────────────────── */
  var demoCards = root.querySelectorAll('.ksv-demo');
  var currentPlayer = null;
  var rafId = null;

  function formatDemoTime(seconds){
    if (!isFinite(seconds) || seconds < 0) seconds = 0;
    var m = Math.floor(seconds / 60);
    var s = Math.floor(seconds % 60);
    return m + ':' + (s < 10 ? '0' + s : s);
  }

  function setDemoVisual(player, state){
    var card = player.card;
    var label = player.stateEl;
    card.classList.remove('is-loading', 'is-playing', 'is-paused');
    if (state) card.classList.add(state);

    if (label){
      if (state === 'is-loading') label.textContent = 'Loading';
      else if (state === 'is-playing') label.textContent = 'Playing';
      else if (state === 'is-paused') label.textContent = 'Paused';
      else label.textContent = 'Play';
    }
    card.setAttribute('aria-pressed', state === 'is-playing' ? 'true' : 'false');
  }

  function updateDemoProgress(player){
    var audio = player.audio;
    var duration = audio.duration || 0;
    var current = audio.currentTime || 0;
    var pct = duration ? Math.max(0, Math.min(1, current / duration)) : 0;

    if (player.progressEl){
      player.progressEl.style.transform = 'scaleX(' + pct + ')';
    }
    if (player.timeEl){
      if (duration){
        player.timeEl.textContent = formatDemoTime(current) + ' / ' + formatDemoTime(duration);
      } else {
        player.timeEl.textContent = formatDemoTime(current);
      }
    }
  }

  function startDemoTicker(player){
    stopDemoTicker();
    function tick(){
      updateDemoProgress(player);
      if (!player.audio.paused && !player.audio.ended){
        rafId = life.frame(tick);
      }
    }
    rafId = life.frame(tick);
  }

  function stopDemoTicker(){
    if (rafId){
      life.cancelFrame(rafId);
      rafId = null;
    }
  }

  function resetDemo(player){
    if (!player) return;
    player.audio.pause();
    player.audio.currentTime = 0;
    updateDemoProgress(player);
    setDemoVisual(player, '');
  }

  function pauseDemo(player){
    if (!player) return;
    player.audio.pause();
    stopDemoTicker();
    updateDemoProgress(player);
    setDemoVisual(player, 'is-paused');
  }

  function playDemo(player){
    if (!player || !player.audioUrl) return;

    if (currentPlayer && currentPlayer !== player){
      resetDemo(currentPlayer);
    }

    currentPlayer = player;
    setDemoVisual(player, 'is-loading');

    var chosen = player; player.audio.play().then(function(){
      if(life.disposed || currentPlayer !== chosen || player.audio.paused)return;
      setDemoVisual(player, 'is-playing');
      updateDemoProgress(player);
      startDemoTicker(player);
    }).catch(function(){
      resetDemo(player);
      if (currentPlayer === player) currentPlayer = null;
    });
  }

  demoCards.forEach(function(card){
    var url = card.getAttribute('data-audio-url');
    var title = card.querySelector('b') ? card.querySelector('b').textContent : 'audio preview';
    var player = {
      card: card,
      audioUrl: url,
      audio: url ? new life.Audio(url) : null,
      progressEl: card.querySelector('.ksv-demo-progress span'),
      timeEl: card.querySelector('.ksv-demo-time'),
      stateEl: card.querySelector('.ksv-demo-state')
    };

    card.setAttribute('role', 'button');
    card.setAttribute('tabindex', '0');
    card.setAttribute('aria-label', (url ? 'Play demo: ' : 'No audio linked for demo: ') + title);
    card.setAttribute('aria-pressed', 'false');

    if (!url || !player.audio){
      card.classList.add('is-disabled');
      if (player.stateEl) player.stateEl.textContent = 'No audio';
      return;
    }

    player.audio.preload = 'metadata';

    player.audio.addEventListener('loadedmetadata', function(){
      updateDemoProgress(player);
    });
    player.audio.addEventListener('timeupdate', function(){
      updateDemoProgress(player);
    });
    player.audio.addEventListener('ended', function(){
      resetDemo(player);
      if (currentPlayer === player) currentPlayer = null;
      stopDemoTicker();
    });
    player.audio.addEventListener('pause', function(){
      setDemoVisual(player, '');
      updateDemoProgress(player);
    });
    player.audio.addEventListener('error', function(){
      resetDemo(player);
      if (player.stateEl) player.stateEl.textContent = 'Error';
      card.classList.add('is-disabled');
      if (currentPlayer === player) currentPlayer = null;
      stopDemoTicker();
    });

    function toggleDemo(){
      if (player.audio.paused){
        playDemo(player);
      } else {
        pauseDemo(player);
      }
    }

    card.addEventListener('click', toggleDemo);
    card.addEventListener('keydown', function(e){
      if (e.key === 'Enter' || e.key === ' '){
        e.preventDefault();
        toggleDemo();
      }
    });
  });

  /* ── STICKY CTA BAR ────────────────────────────── */
  var heroEl = root.querySelector('[data-ksv-hero]');
  var sticky = document.querySelector(('.ksv-sticky--' + sectionId + ''));
  if (heroEl && sticky && 'IntersectionObserver' in window){
    var stickyIO = new life.IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting){
          sticky.classList.add('is-visible');
          sticky.setAttribute('aria-hidden', 'false');
        } else {
          sticky.classList.remove('is-visible');
          sticky.setAttribute('aria-hidden', 'true');
        }
      });
    }, { threshold: 0 });
    stickyIO.observe(heroEl);
  }

},
"htf": function(root,config,life){const sectionId=root.dataset.krId;

  if (!root) return;

  /* ── SCROLL REVEAL ── */
  var reveals = root.querySelectorAll('[data-reveal]');
  if (!('IntersectionObserver' in window)) {
    reveals.forEach(function(el){ el.classList.add('is-visible'); });
  } else {
    var revealIO = new life.IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('is-visible'); revealIO.unobserve(e.target); }
      });
    }, { threshold: 0.08 });
    reveals.forEach(function(el){ revealIO.observe(el); });
  }

  /* ── COUNTERS ── */
  var counters = root.querySelectorAll('[data-count]');
  if (counters.length && 'IntersectionObserver' in window){
    var countIO = new life.IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting) return;
        var el = e.target;
        var target = parseInt(el.getAttribute('data-count'), 10);
        if (isNaN(target)){ countIO.unobserve(el); return; }
        var duration = 1800, startTime = null;
        function tick(ts){
          if (!startTime) startTime = ts;
          var progress = Math.min((ts - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(eased * target);
          if (progress < 1) life.frame(tick); else el.textContent = target;
        }
        life.frame(tick);
        countIO.unobserve(el);
      });
    }, { threshold: 0.5 });
    counters.forEach(function(el){ countIO.observe(el); });
  }

  /* ── MARQUEE PAUSE ── */
  var marquee = root.querySelector('.htf-marquee');
  var mWrap   = root.querySelector('.htf-marquee-wrap');
  if (marquee && mWrap){
    mWrap.addEventListener('mouseenter', function(){ marquee.style.animationPlayState = 'paused'; });
    mWrap.addEventListener('mouseleave', function(){ marquee.style.animationPlayState = 'running'; });
  }

  /* ════ PRO PLAYER ════ */
  var playerEl = root.querySelector('[data-htf-player]');
  if (playerEl){
    var audio = new life.Audio();
audio.addEventListener("play",()=>window.KrosperSystem?.pauseOthers(audio));
    audio.preload = 'none';

    var trackEls = Array.prototype.slice.call(playerEl.querySelectorAll('[data-htf-track]'));
    var tracks = trackEls.map(function(el){
      var t = el.querySelector('.htf-track-title');
      var s = el.querySelector('.htf-track-sub');
      return {
        el: el,
        url: el.getAttribute('data-htf-url') || '',
        title: t ? t.textContent.trim() : 'Preview',
        sub: s ? s.textContent.trim() : '',
        durEl: el.querySelector('[data-htf-track-dur]'),
        probed: false
      };
    });

    var titleEl  = playerEl.querySelector('[data-htf-title]');
    var subEl    = playerEl.querySelector('[data-htf-sub]');
    var curEl    = playerEl.querySelector('[data-htf-cur]');
    var durTotEl = playerEl.querySelector('[data-htf-dur]');
    var fillEl   = playerEl.querySelector('[data-htf-fill]');
    var bufEl    = playerEl.querySelector('[data-htf-buffer]');
    var thumbEl  = playerEl.querySelector('[data-htf-thumb]');
    var seekEl   = playerEl.querySelector('[data-htf-seek]');
    var trackBar = playerEl.querySelector('.htf-seek-track');
    var toggleBtn= playerEl.querySelector('[data-htf-toggle]');
    var prevBtn  = playerEl.querySelector('[data-htf-prev]');
    var nextBtn  = playerEl.querySelector('[data-htf-next]');
    var muteBtn  = playerEl.querySelector('[data-htf-mute]');
    var volInput = playerEl.querySelector('[data-htf-vol]');

    var current = -1, scrubbing = false, rafId = null, trackW = 0, lastVol = 1;

    function fmt(s){
      if (!isFinite(s) || s < 0) s = 0;
      var m = Math.floor(s / 60), sec = Math.floor(s % 60);
      return m + ':' + (sec < 10 ? '0' + sec : sec);
    }
    function isTimeStr(v){ return typeof v === 'string' && /\d+:\d{2}/.test(v); }
    function firstPlayable(){ for (var i=0;i<tracks.length;i++){ if (tracks[i].url) return i; } return -1; }
    function nextPlayable(from){ for (var i=from+1;i<tracks.length;i++){ if (tracks[i].url) return i; } return -1; }
    function prevPlayable(from){ for (var i=from-1;i>=0;i--){ if (tracks[i].url) return i; } return -1; }
    function refreshW(){ if (trackBar) trackW = trackBar.getBoundingClientRect().width; }

    function setActiveRow(i){
      tracks.forEach(function(t, idx){
        if (idx === i){ t.el.classList.add('is-active'); }
        else { t.el.classList.remove('is-active', 'is-playing'); }
        t.el.setAttribute('aria-current', idx === i ? 'true' : 'false');
      });
    }
    function setPlayingState(playing){
      playerEl.classList.toggle('is-playing', playing);
      if (toggleBtn) toggleBtn.setAttribute('aria-label', playing ? 'Pause' : 'Play');
      if (current > -1 && tracks[current]){ tracks[current].el.classList.toggle('is-playing', playing); }
    }
    function updateProgress(){
      var d = audio.duration || 0, c = audio.currentTime || 0;
      var pct = d ? Math.max(0, Math.min(1, c / d)) : 0;
      if (!scrubbing){
        if (fillEl)  fillEl.style.transform  = 'scaleX(' + pct + ')';
        if (thumbEl) thumbEl.style.transform = 'translate3d(' + (pct * trackW) + 'px,-50%,0)';
      }
      if (curEl) curEl.textContent = fmt(c);
      if (durTotEl && d) durTotEl.textContent = fmt(d);
      if (seekEl) seekEl.setAttribute('aria-valuenow', Math.round(pct * 100));
    }
    function updateBuffer(){
      try{
        if (audio.buffered && audio.buffered.length && audio.duration){
          var end = audio.buffered.end(audio.buffered.length - 1);
          var p = Math.max(0, Math.min(1, end / audio.duration));
          if (bufEl) bufEl.style.transform = 'scaleX(' + p + ')';
        }
      } catch(e){}
    }
    function startRaf(){
      stopRaf();
      function tick(){
        updateProgress();
        if (!audio.paused && !audio.ended){ rafId = life.frame(tick); }
      }
      rafId = life.frame(tick);
    }
    function stopRaf(){ if (rafId){ life.cancelFrame(rafId); rafId = null; } }

    function load(i, autoplay){
      if (i < 0 || i >= tracks.length || !tracks[i].url) return;
      current = i;
      refreshW();
      audio.src = tracks[i].url;
      if (titleEl) titleEl.textContent = tracks[i].title;
      if (subEl)   subEl.textContent   = tracks[i].sub || '';
      if (fillEl)  fillEl.style.transform  = 'scaleX(0)';
      if (bufEl)   bufEl.style.transform   = 'scaleX(0)';
      if (thumbEl) thumbEl.style.transform = 'translate3d(0,-50%,0)';
      if (curEl)   curEl.textContent = '0:00';
      if (durTotEl){
        var rowDur = tracks[i].durEl ? tracks[i].durEl.textContent.trim() : '';
        durTotEl.textContent = isTimeStr(rowDur) ? rowDur : '0:00';
      }
      setActiveRow(i);
      if (autoplay) play();
    }
    function play(){
      if (current < 0){ var f = firstPlayable(); if (f < 0) return; load(f, false); }
      var pr = audio.play();
      if (pr && pr.then){
        pr.then(function(){ setPlayingState(true); refreshW(); startRaf(); })
          .catch(function(){ setPlayingState(false); });
      } else { setPlayingState(true); startRaf(); }
    }
    function pause(){ audio.pause(); setPlayingState(false); stopRaf(); }
    function toggle(){ if (audio.paused) play(); else pause(); }
    function playIndex(i){ if (i === current){ toggle(); return; } load(i, true); }
    function goNext(){ var n = nextPlayable(current); if (n > -1) load(n, true); }
    function goPrev(){
      if (audio.currentTime > 3){ audio.currentTime = 0; updateProgress(); return; }
      var p = prevPlayable(current);
      if (p > -1) load(p, true); else { audio.currentTime = 0; updateProgress(); }
    }

    audio.addEventListener('loadedmetadata', function(){ refreshW(); updateProgress(); });
    audio.addEventListener('progress', updateBuffer);
    audio.addEventListener('timeupdate', function(){ if (audio.paused) updateProgress(); });
    audio.addEventListener('ended', function(){
      setPlayingState(false); stopRaf();
      var n = nextPlayable(current);
      if (n > -1){ load(n, true); }
      else { var f = firstPlayable(); if (f > -1) load(f, false); }
    });
    audio.addEventListener('error', function(){ setPlayingState(false); stopRaf(); });

    if (toggleBtn) toggleBtn.addEventListener('click', toggle);
    if (nextBtn)   nextBtn.addEventListener('click', goNext);
    if (prevBtn)   prevBtn.addEventListener('click', goPrev);

    tracks.forEach(function(t, i){
      if (!t.url){
        t.el.classList.add('is-disabled');
        t.el.setAttribute('aria-disabled', 'true');
        if (t.durEl && !isTimeStr(t.durEl.textContent.trim())) t.durEl.textContent = '—';
        return;
      }
      t.el.setAttribute('role', 'button');
      t.el.setAttribute('tabindex', '0');
      t.el.addEventListener('click', function(){ playIndex(i); });
      t.el.addEventListener('keydown', function(e){
        if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); playIndex(i); }
      });
    });

    function seekFrac(clientX){
      if (!trackBar) return 0;
      var rect = trackBar.getBoundingClientRect();
      trackW = rect.width;
      return Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
    }
    function previewSeek(frac){
      if (fillEl)  fillEl.style.transform  = 'scaleX(' + frac + ')';
      if (thumbEl) thumbEl.style.transform = 'translate3d(' + (frac * trackW) + 'px,-50%,0)';
      if (curEl && audio.duration) curEl.textContent = fmt(frac * audio.duration);
    }
    if (seekEl){
      seekEl.addEventListener('pointerdown', function(e){
        if (current < 0){ var f = firstPlayable(); if (f < 0) return; load(f, false); }
        scrubbing = true;
        try{ seekEl.setPointerCapture && seekEl.setPointerCapture(e.pointerId); } catch(_){}
        previewSeek(seekFrac(e.clientX));
      });
      seekEl.addEventListener('pointermove', function(e){
        if (!scrubbing) return;
        previewSeek(seekFrac(e.clientX));
      });
      var endScrub = function(e){
        if (!scrubbing) return;
        scrubbing = false;
        try{ seekEl.releasePointerCapture && seekEl.releasePointerCapture(e.pointerId); } catch(_){}
        var fr = seekFrac(e.clientX);
        if (audio.duration){ audio.currentTime = fr * audio.duration; }
        updateProgress();
      };
      seekEl.addEventListener('pointerup', endScrub);
      seekEl.addEventListener('pointercancel', endScrub);

      seekEl.setAttribute('role', 'slider');
      seekEl.setAttribute('tabindex', '0');
      seekEl.addEventListener('keydown', function(e){
        if (!audio.duration) return;
        if (e.key === 'ArrowRight'){ e.preventDefault(); audio.currentTime = Math.min(audio.duration, audio.currentTime + 5); updateProgress(); }
        else if (e.key === 'ArrowLeft'){ e.preventDefault(); audio.currentTime = Math.max(0, audio.currentTime - 5); updateProgress(); }
        else if (e.key === 'Home'){ e.preventDefault(); audio.currentTime = 0; updateProgress(); }
        else if (e.key === 'End'){ e.preventDefault(); audio.currentTime = audio.duration; updateProgress(); }
      });
    }

    if (volInput){
      audio.volume = parseFloat(volInput.value);
      volInput.style.setProperty('--vol', (parseFloat(volInput.value) * 100) + '%');
      volInput.addEventListener('input', function(){
        var v = parseFloat(volInput.value);
        audio.volume = v; audio.muted = (v === 0);
        volInput.style.setProperty('--vol', (v * 100) + '%');
        playerEl.classList.toggle('is-muted', v === 0);
        if (v > 0) lastVol = v;
      });
    }
    if (muteBtn){
      muteBtn.addEventListener('click', function(){
        if (audio.muted || audio.volume === 0){
          audio.muted = false;
          var v = lastVol || 1; audio.volume = v;
          if (volInput){ volInput.value = v; volInput.style.setProperty('--vol', (v * 100) + '%'); }
          playerEl.classList.remove('is-muted');
        } else {
          lastVol = audio.volume; audio.muted = true;
          if (volInput){ volInput.value = 0; volInput.style.setProperty('--vol', '0%'); }
          playerEl.classList.add('is-muted');
        }
      });
    }

    life.on(window,'resize', refreshW);

    function probeDurations(){
      tracks.forEach(function(t){
        if (!t.url || !t.durEl || t.probed) return;
        t.probed = true;
        try{
          var a = new life.Audio();
a.addEventListener("play",()=>window.KrosperSystem?.pauseOthers(a));
          a.preload = 'metadata';
          a.src = t.url;
          a.addEventListener('loadedmetadata', function(){
            if (isFinite(a.duration) && a.duration > 0){ t.durEl.textContent = fmt(a.duration); }
          });
          a.addEventListener('error', function(){});
        } catch(e){}
      });
    }
    if ('IntersectionObserver' in window){
      var probeIO = new life.IntersectionObserver(function(entries){
        entries.forEach(function(e){ if (e.isIntersecting){ probeDurations(); probeIO.disconnect(); } });
      }, { rootMargin: '200px' });
      probeIO.observe(playerEl);
    } else { probeDurations(); }

    var f0 = firstPlayable();
    if (f0 > -1) load(f0, false);
  }

  /* ── STICKY CTA BAR ── */
  var heroEl = root.querySelector('[data-htf-hero]');
  var sticky = document.querySelector(('.htf-sticky--' + sectionId + ''));
  if (heroEl && sticky && 'IntersectionObserver' in window){
    var stickyIO = new life.IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting){ sticky.classList.add('is-visible'); sticky.setAttribute('aria-hidden', 'false'); }
        else { sticky.classList.remove('is-visible'); sticky.setAttribute('aria-hidden', 'true'); }
      });
    }, { threshold: 0 });
    stickyIO.observe(heroEl);
  }

}};
  const instances = new Map();
  function lifecycle(root) {
    const abort = new AbortController(), timers = new Set(), intervals = new Set(), frames = new Set(), observers = new Set(), media = new Set();
    const life = {
      disposed:false,
      on(target,type,fn,options={}) { target?.addEventListener(type,fn,{...(typeof options==='boolean'?{capture:options}:options),signal:abort.signal}); },
      frame(fn) { if(life.disposed)return 0;const id=requestAnimationFrame(t=>{frames.delete(id);if(!life.disposed)fn(t);});frames.add(id);return id; },
      cancelFrame(id) { cancelAnimationFrame(id);frames.delete(id); },
      timeout(fn,ms) { if(life.disposed)return 0;const id=setTimeout(()=>{timers.delete(id);if(!life.disposed)fn();},ms);timers.add(id);return id; },
      clearTimeout(id) { clearTimeout(id);timers.delete(id); },
      interval(fn,ms) { if(life.disposed)return 0;const id=setInterval(()=>{if(!life.disposed)fn();},ms);intervals.add(id);return id; },
      clearInterval(id) { clearInterval(id);intervals.delete(id); },
      dispose() { life.disposed=true;abort.abort();timers.forEach(clearTimeout);intervals.forEach(clearInterval);frames.forEach(cancelAnimationFrame);observers.forEach(o=>o.disconnect());media.forEach(a=>{a.pause();a.removeAttribute('src');a.load();window.KrosperSystem?.unregisterMedia(a);});root.querySelectorAll('audio,video').forEach(a=>a.pause()); }
    };
    life.Audio=function(...args){const audio=new Audio(...args);media.add(audio);audio.addEventListener('play',()=>{window.KrosperSystem?.registerMedia(audio);window.KrosperSystem?.pauseOthers(audio);},{signal:abort.signal});return audio;};
    for(const name of ['IntersectionObserver','ResizeObserver']) if(window[name])life[name]=function(...args){const observer=new window[name](...args);observers.add(observer);return observer;};
    life.on(window,'pagehide',()=>{media.forEach(a=>a.pause());root.querySelectorAll('video').forEach(v=>v.pause());});
    return life;
  }
  function mount(root) {
    if(instances.has(root))return;
    const factory=factories[root.dataset.krCampaign];if(!factory)return;
    let config={};try{config=JSON.parse(root.querySelector('[data-kr-campaign-config]')?.textContent||'{}');}catch{}
    const life=lifecycle(root);instances.set(root,life);
    try { factory(root,config,life); }
    catch(error) { life.dispose();root.querySelectorAll('[data-reveal],[data-r]').forEach(el=>{el.classList.add('on','is-visible','is-loaded');el.style.opacity='1';el.style.transform='none';});console.error('KROSPER campaign could not initialize',root.dataset.krCampaign,error); }
  }
  const mountInside=target=>{if(target.matches?.('[data-kr-campaign]'))mount(target);target.querySelectorAll('[data-kr-campaign]').forEach(mount);};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mountInside(document),{once:true});else mountInside(document);
  document.addEventListener('shopify:section:load',e=>mountInside(e.target));
  document.addEventListener('shopify:section:unload',e=>{for(const [root,life]of instances)if(e.target.contains(root)){life.dispose();instances.delete(root);}});
})();
